import React from 'react';
import { useObservable } from 'react-use-observable';

import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import { useFormikContext } from 'formik';
import type { FieldProps } from 'formik';
import useBoolean from 'v2/hooks/useBoolean';
import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

import { Dialog } from './Dialog';

type IProps = FieldProps;

export const SelectAffiliate = ({ form, field }: IProps) => {
  if (!form || !field) {
    throw new Error('You must provide a Formik Provider in order to use this component');
  }

  const { setFieldValue } = useFormikContext();

  const selectedAffiliates = field?.value as IAffiliateOption[];

  useObservable(() => selectAffiliateService.loadAffiliates(), []);
  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const [isModalOpen, setModalState] = useBoolean();

  const selectedAffiliatesQuantity = selectedAffiliates.length;
  const hasSelectAffiliates = selectedAffiliatesQuantity;

  const handleUncheckAll = () => setFieldValue(field?.name, []);

  return (
    <>
      <label className='mb-1 block text-sm'>Afiliados</label>

      <Input
        placeholder={isLoadingAffiliates ? 'Carregando seus afiliados...' : 'Selecione seus afiliados'}
        value={hasSelectAffiliates ? `${selectedAffiliatesQuantity} Afiliado(s) ...` : ''}
        readOnly
        onClick={setModalState.toTrue}
        suffix={
          <>
            <SearchOutlined style={{ fontSize: 20 }} />
            {!!hasSelectAffiliates && <CloseOutlined style={{ fontSize: 20 }} onClick={handleUncheckAll} />}
          </>
        }
      />

      <Dialog
        isOpen={isModalOpen}
        onClose={setModalState.toFalse}
        selectedQuantity={selectedAffiliatesQuantity}
        selectedAffiliates={selectedAffiliates}
        handleUncheckAll={handleUncheckAll}
      />
    </>
  );
};
